import tippy from 'tippy.js';

export const initTippy = (root = document) => {
    const tippyElements = root.querySelectorAll('[js-tippy]');
    if (!tippyElements.length) return;

    tippyElements.forEach(element => {
        if (element._tippy) {
            return;
        }

        const isVariantTooltip =
            element.classList.contains('color-swatch') ||
            element.classList.contains('variation-radio-color');

        tippy(element, {
            content: element.getAttribute('js-tippy'),
            allowHTML: true,
            trigger: isVariantTooltip ? 'mouseenter' : 'mouseenter click',
            ...(isVariantTooltip
                ? {
                      touch: false,
                      hideOnClick: false,
                  }
                : {}),
        });
    });
};

export const tippyModule = () => {
    initTippy(document);
};
